<template>
  <div class="digital-article-weixin">
    <DigitalArticleView
      width="100%"
      :init-show="true"
      :init-show-prev-and-next="this.type === 'paper' && readModel === 2"
      :init-show-close="false"
      :init-show-back="true"
      :init-article-text="articleText"
      :audio-src="audio"
      @onBack="onBackArticleView"
      @onPrev="onPrevArticleView"
      @onNext="onNextArticleView"
      ref="articleView"
    ></DigitalArticleView>
    <div class="digital-loading" v-if="dataLoading">
      <div class="text">加载中...</div>
    </div>
  </div>
</template>
<script>
import DigitalArticleView from '../components/digital/DigitalArticleView'
import wxSetting from '@components/common/wxSetting'
import { formatDigitalArticle } from '@/utils'

export default {
  name: 'DigitalArticleMobile',
  mixins: [wxSetting],
  components: {
    DigitalArticleView
  },
  data() {
    return {
      dataLoading: false,
      articles: [],
      epaperId: 1,
      pageIndex: 0,
      pageTotal: 0,
      articleIndex: 0,
      articleXiaoYangId: 0,
      articleTitle: '',
      articleText: '',
      audio: '',
      readingLog: {},
      type: this.$route.query.type,
      readModel: 0,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      }
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  mounted() {
    $('.common-header').hide()
    this.dataLoading = true
    this.$store.commit('book/UPDATE_BOOK_DATA', staticOptions)
    this.getXiaoYangDetail(this.$route.query.id, (data) => {
      this.epaperId = data.epaperId
      this.articleXiaoYangId = this.$route.query.id
      this.articleTitle = data.title
      this.articleText = data.content
      this.audio = data.audio
      this.$setDocumentTitle(data.title)
      this.$refs.articleView.articleId = this.articleXiaoYangId
      this.$refs.articleView.title = data.title
      this.$refs.articleView.creator = data.creator
      this.weixinShare(this.$route.query.id, data.title)
      // 从缓存中读取上一次的阅读的页数
      this.readingLog = JSON.parse(localStorage.getItem('readingLog')) || {}
      // 请求书刊详情
      if (data.module) {
        this.type = data.module.indexOf('epaper') > -1 ? 'paper' : 'book'
      }
      const params = {
        id: data.epaperId
      }
      const book = window.staticOptions

      // 总页数
      this.pageTotal = book.pageNumber
      this.readModel = book.readModel
      // 导览文章列表
      if (book.catalog) {
        let catalog = JSON.parse(book.catalog)
        this.articles = (catalog ? this.processCatalogList(catalog.catalogList, book.displayPageNo) : []) || []
      } else {
        this.articles = []
      }
      if (book.displayOrNot) {
        this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', JSON.parse(book.displayOrNot))
      }
      // 通过小样ID找到页面数和文章数
      for (let a in this.articles) {
        if (this.articles.hasOwnProperty(a)) {
          if (this.articles[a].children) {
            for (let b in this.articles[a].children) {
              if (this.articles[a].children.hasOwnProperty(b)) {
                if (this.articles[a].children[b].xiaoYangId == this.$route.query.id) {
                  this.pageIndex = this.articles[a].page
                  this.articleIndex = parseInt(b) + 1
                  console.log('this.pageIndex', this.pageIndex)
                  console.log('this.articleIndex', this.articleIndex)
                }
              }
            }
          }
        }
      }
      //
      setTimeout(() => {
        this.dataLoading = false
      }, 1000)
    })
  },
  methods: {
    // 微信分享
    weixinShare(articleId, articleTitle) {
      let shareUrl = window.location.href.split('#')[0]
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        const wxParams = {
          id: this.epaperId,
          currentUrl: shareUrl
        }
      } else {
        console.log('不是微信浏览器')
      }
    },
    // 书刊部分展示时，删除冗余页码目录
    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length; ) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    getXiaoYangDetailInfo(xiaoYangId) {
      if (xiaoYangId) {
        this.getXiaoYangDetail(xiaoYangId, (data) => {
          this.articleXiaoYangId = xiaoYangId
          this.articleTitle = data.title
          this.articleText = data.content
          this.audio = data.audio
          this.$refs.articleView.articleId = this.articleXiaoYangId
          this.$refs.articleView.title = data.title
          this.$refs.articleView.creator = data.creator
          document.title = data.title
          this.weixinShare(xiaoYangId, data.title)
        })
      }
    },
    getXiaoYangDetail(xiaoYangId, callback) {
      // 根据小样ID获取内容详情
      window.staticOptions.daYangList.forEach((edition) => {
        edition.xiaoYangList.forEach((xiaoYang) => {
          if (xiaoYang.id == xiaoYangId) {
            callback && callback(formatDigitalArticle({
              data: {
                data: xiaoYang
              }
            }).data.data)
            return
          }
        })
      })
    },
    repairAlert() {
      // 移动端时需要修复一下弹窗的层级问题
      if (this.isMobile) {
        setTimeout(() => {
          for (let a in document.body.children) {
            if (document.body.children.hasOwnProperty(a)) {
              let tabindex = parseInt(document.body.children[a].getAttribute('tabindex'))
              let className = document.body.children[a].className
              if (className.indexOf('el-message-box__wrapper') >= 0 && tabindex === -1) {
                document.body.children[a].style.zIndex = 10000
              } else if (className.indexOf('v-modal') >= 0 && tabindex === 0) {
                document.body.children[a].style.zIndex = 9999
              }
            }
          }
        }, 100)
      }
    },
    saveReadingLog(pageIndex) {
      // TODO切换文章后返回相应版面需修改
      this.readingLog[this.epaperId] = parseInt(pageIndex)
      sessionStorage.setItem('readingLog', JSON.stringify(this.readingLog))
    },
    onBackArticleView() {
      if (window.history.length <= 2 || this.$route.query.from === 'personal') {
        let path = '#/'
        window.location.href = window.location.origin + window.location.pathname + path
      } else {
        window.history.go(-1)
      }
    },
    onPrevArticleView() {
      if (this.pageIndex === 1 && this.articleIndex === 1) {
        this.$alert('已经是第一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex - 1
      let xiaoYangId = this.articles[this.pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
      if (xiaoYangId === 0 && this.pageIndex === 1) {
        return
      }
      if (xiaoYangId === 0) {
        let pageIndex = this.pageIndex - 1
        articleIndex = this.articles[pageIndex - 1]?.children.length
        xiaoYangId = this.articles[pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
        if (xiaoYangId === 0) {
          return
        }
        this.pageIndex = pageIndex
        this.saveReadingLog(pageIndex)
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    },
    onNextArticleView() {
      if (this.pageIndex === this.pageTotal && this.articleIndex === this.articles[this.pageIndex - 1].children.length) {
        this.$alert('已经是最后一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex + 1
      let xiaoYangId = this.articles[this.pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
      if (xiaoYangId === 0 && this.pageIndex === this.pageTotal) {
        return
      }
      if (xiaoYangId === 0) {
        let pageIndex = this.pageIndex + 1
        articleIndex = 1
        xiaoYangId = this.articles[pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
        if (xiaoYangId === 0) {
          return
        }
        this.pageIndex = pageIndex
        this.saveReadingLog(pageIndex)
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    }
  },
  destroyed() {
    $('.common-header').show()
  }
}
</script>
<style lang="scss">
.digital-article-weixin {
  width: 100%;
  height: 100%;
  .digital-article-view {
    position: relative;
    margin: auto;
  }
}
</style>
